// extracted by mini-css-extract-plugin
export default {"wrapper":"PrivacyPolicyAdd_wrapper__QNTzA","heading":"PrivacyPolicyAdd_heading__HoBnM","formContainer":"PrivacyPolicyAdd_formContainer__ZjBK6"};